import { render } from "./province-list.vue?vue&type=template&id=2080e90c"
import script from "./province-list.vue?vue&type=script&lang=js"
export * from "./province-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__